import { create } from 'zustand'
import apiHelper from '@/network/api'

interface KeywordPermissionState {
  isLoading: boolean
  hasPermission: boolean | null
  checkPermission: (threadsUserId: string) => Promise<boolean>
  setIsLoading: (loading: boolean) => void
  setHasPermission: (hasPermission: boolean) => void
}

const useKeywordPermissionStore = create<KeywordPermissionState>((set) => ({
  isLoading: false,
  hasPermission: null,
  setIsLoading: (loading) => set({ isLoading: loading }),
  setHasPermission: (hasPermission) => set({ hasPermission }),
  checkPermission: async (threadsUserId: string) => {
    set({ isLoading: true })
    set({ hasPermission: false })

    try {
      const result = await apiHelper(null).get(`keyword/has_permission?threadsUserId=${threadsUserId}`)
      const hasPermission = result.data.hasPermission
      set({ hasPermission })
      set({ isLoading: false })
      return hasPermission
    } catch (error) {
      console.error("Permission check failed:", error)
      set({ hasPermission: false })
      set({ isLoading: false })
      return false
    }
  }
}))

export default useKeywordPermissionStore
